// extracted by mini-css-extract-plugin
module.exports = {"noPhotoIcon":"product-view-nophotoicon_noPhotoIcon__2gAnt"};